import React, { Component } from 'react';
import { Header, Table, Button, Modal } from 'semantic-ui-react'
import axios from 'axios'
import { base, serverIp, PAYMENT_TYPE_PRINTING_CHARGE, PAYMENT_TYPE_STOCK} from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants';


class GroupPayment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false
        }
    }

    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });
    }

    makeGroupStockDeliveryPaymentByShirtType = () => {
        console.log("cpx1 ====== makeGroupStockDeliveryPaymentByShirtType");

        this.setState({ loading: true, modalOpen: false })

        axios.post(serverIp + 'stockPayment/makeGroupStockDeliveryPaymentByShirtType', {
            apiKey: "PrintB@da7",
            shirtType: this.props.item.itemCode,
            adminEmail: this.props.user.email,
            itemType: this.props.paymentType,
        })
            .then((response) => {
                this.setState({ loading: false, modalOpen: false });

                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    alert("Suucess!!! All " + this.props.item.itemCode + " paid " + response.data.message);

                } else {
                    console.log("FAILED");
                    alert("FAILED!!! TO make payment:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false,
                })
            });
    }


    render() {

        const paymentUi = <div>
            <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                <Modal.Header>
                    Make Payment
            </Modal.Header>
                <Modal.Content>
                    <h3>Make Payment:{this.props.item.itemCode} {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(this.props.item.itemTotal)} ?</h3>
                </Modal.Content>
                <Modal.Actions>
                    <Button negative onClick={this.closeModal}>No</Button>
                    <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.makeGroupStockDeliveryPaymentByShirtType} />
                </Modal.Actions>
            </Modal>
            <Button onClick={this.openModal} color='GREE'> PAY ALL {this.props.item.itemCode}</Button>
        </div>

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <h3>{this.props.item.itemCode}
                    - {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(this.props.item.itemTotal)}
                    - {this.props.item.numOrders} orders
                - {paymentUi}
                </h3>

            </div>
        );
    }
}

export default GroupPayment;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/GroupPayment.js